import { LabelSizeValue } from '@common/commonLists';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { ConfigManager } from '@utils/ConfigManager';

export const domainUrl = ConfigManager.domainUrl;
export const apiUrl = ConfigManager.apiUrl;

export const orderUrls = {
  orderSheet: (id: number) =>
    `${domainUrl}/Document/OrderSummary/${id}?controls=true`,
  customerConfirmation: (id: number) =>
    `${domainUrl}Document/CustomerRateConfirmation/${id}?controls=true`,
  invoice: (id: number) => {
    return handleNavigationForBOLRateConAndInvoice('Invoice', id);
  },
  profile: (id: number) => `${domainUrl}Customer/Details/${id}`,
  carrierDetails: (id: number) => `${domainUrl}/Carrier/Details/${id}`,
  editHistory: (id: number) => `${domainUrl}Order/EditHistory/${id}`,
  officeDetails: (id: number) => `${domainUrl}/Office/Details/${id}`,
  orderDetails: (id: number) => `${domainUrl}/Order/Details/${id}`,
  claim: (id: number) => `${domainUrl}/Claim/${id}`,
};

export const carrierUrls = {
  rateConfirmation: (id: number) => {
    return handleNavigationForBOLRateConAndInvoice(
      'CarrierRateConfirmation',
      id,
    );
  },
  billOfLading: (id: number) => {
    return handleNavigationForBOLRateConAndInvoice('BillOfLading', id);
  },
  shippingLabel: (id: number, size: LabelSizeValue = '4x6') => {
    return handleNavigationForShippingLabel(id, size);
  },
  profile: (id: number) => `${domainUrl}Carrier/Details/${id}`,
  claim: (id: number) => `${domainUrl}Claim/${id}`,
  playLists: () => `${domainUrl}Carrier/Playlists`,
  balanceReport: (id: number) =>
    `${domainUrl}Document/CarrierOpenBalances/${id}?controls=true`,
};

const handleNavigationForBOLRateConAndInvoice = (str: string, id: number) => {
  if (isFeatureFlagEnabled(FeatureFlags.V4BolRateConInvoice)()) {
    return `${domainUrl}Document/${str}/${id}?controls=true`;
  }
  return `${ConfigManager.v3Host}/Document/${str}/${id}?controls=true`;
};
const handleNavigationForShippingLabel = (id: number, size: LabelSizeValue) => {
  return `${
    ConfigManager.pdfApiUrl
  }/api/pdf/shippinglabel/${id}?size=${encodeURIComponent(size)}`;
};
export const ltlUrls = {
  quoteInfoPDF: (id: number) => {
    return `${ConfigManager.v3Host}/api/SystemDocument/LTLQuoteParametersDocument/${id}?format=pdf`;
  },
  quoteInfoV4PDF: (id: number) => {
    return `${ConfigManager.pdfApiUrl}/api/pdf/ltlquoteparametersdocument/${id}?format=pdf`;
  },
};

export const creditApplicationUrls = {
  bureauReportsPdf: (id: number) =>
    `${ConfigManager.pdfApiUrl}/api/pdf/creditapplicationpdf/${id}`,
};
export const equipmentSearchUrl = `${domainUrl}carrier/equipmentsearch`;

export const customerUrls = {
  report: (id: number) => {
    return `${domainUrl}/Document/CustomerOpenBalances/${id}?controls=true`;
  },
};

export const dashboardUrls = {
  report: (id: number) => {
    return `${domainUrl}/Document/CustomerOpenBalances/${id}?controls=true&overdueOnly=true`;
  },
};

export const v4ServeDocumentUrl = {
  doc: (url: string) => {
    return `${ConfigManager.apiUrl}/api/reporting/servedocument?url=${url}`;
  },
};

export const customerUrl = {
  customerOpenInvoices: (id: number) =>
    `${domainUrl}/Document/CustomerOpenBalances/${id}?controls=true&invoicedOnly=true`,
  customerPastDueInvoices: (id: number) =>
    `${domainUrl}/Document/PastDueInvoices/${id}?controls=true`,
  customerOutstandingBalances: (id: number) =>
    `${domainUrl}/Document/CustomerOpenBalances/${id}?controls=true`,
  productCatalogSampleCsvDownloadLink: () =>
    //`${ConfigManager.v3Host}/api/document/servedocument/?url=Global%20Docs/LTL%20Catalog%20Import%20Template.csv`,
    `${v4ServeDocumentUrl.doc(
      'Global%20Docs/LTL%20Catalog%20Import%20Template.csv',
    )}`,
  customerQuoteCsvDownloadLink: () =>
    //`${ConfigManager.v3Host}/api/document/servedocument/?url=Global%20Docs/Quote_Import_Template.csv`,
    `${v4ServeDocumentUrl.doc('Global%20Docs/Quote_Import_Template.csv')}`,
  customerDetails: (id: number) => `${domainUrl}/Customer/Details/${id}`,
  customerSystemDocuments: (invoiceUrl: string) =>
    `${ConfigManager.apiUrl}/${invoiceUrl}`,
};

export const factoringCompanyUrls = {
  profile: (id: number) => `${domainUrl}/FactoringCompany/Details/${id}`,
};

export const prospectUrls = {
  sampleDocumentLink: () =>
    `${v4ServeDocumentUrl.doc(
      'Global%20Docs/Prospect%20Import%20Template.csv',
    )}`,
};

export const userDetailsUrl = {
  img: (url: string) => `${v4ServeDocumentUrl.doc(url)}`,
};
